import { ImprovedCottonEnum } from '@/common/constants/improved.cotton.constants';
import i18n from '@/i18n';
import { IMeasureState } from '../models';

export const MeasureState: IMeasureState = {
  load: null,
  loadLoading: true,
  transportType: [],
  contractList: [],
  harvestType: [
    { value: 'MANUAL', label: i18n.t('manual') as string },
    { value: 'COMBINE', label: i18n.t('combine') as string },
    { value: 'GROUND_HARVESTED', label: i18n.t('grounded') as string },
  ],
  harvestTechniqueType: [
    {
      value: '1',
      label: i18n.t('technics.type.first_term') as string,
    },
    {
      value: '2',
      label: i18n.t('technics.type.second_term') as string,
    },
    {
      value: '3',
      label: i18n.t('technics.type.third_term') as string,
    },
  ],
  isManageContractLoading: false,
  improvedCottonStandarts: [
    {
      value: ImprovedCottonEnum.BETTER_COTTON,
      label: 'Better Cotton',
    },
    {
      value: ImprovedCottonEnum.ORGANIC,
      label: 'Organic Cotton',
    },
    {
      value: ImprovedCottonEnum.COTTON_WITH_STICKINESS,
      label: 'Cotton with stickiness',
    },
  ],
  isManageGrainContractLoading: false,
};
